import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers";
import { appErrorMiddleware } from "./appErrorMiddleware";

/**
 * SCRUM-595: createStore (deprecated in redux 5) -> configureStore. The legacy
 * combineReducers tree is reused unchanged; configureStore bundles redux-thunk
 * and the devtools wiring that store.js previously set up by hand.
 *
 * serializableCheck remains disabled because legacy slices still contain
 * Dates, class instances and large blobs. immutableCheck stays enabled in
 * development/test so state mutations fail fast, without production overhead.
 *
 * SCRUM-840: appErrorMiddleware is the central error->toast home for RTK
 * write-thunks built with createAppAsyncThunk (their rejections flow to the
 * GET_ERRORS hub without a per-thunk catch).
 */
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: process.env.NODE_ENV !== "production",
    }).concat(appErrorMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
